module.exports = __webpack_public_path__ + "img/kpdlpzYsck.e4465652.png";